<template>
	
<core-card-foot-stat :value="value" type="rating" :text="field.label" />

</template>

<script>

export default {

	props: ['item', 'field'],

	computed: {

		value: function() {

			return this.item.user.rating_avg

		}

	}

}

</script>

<style scoped>

</style>
